export default __webpack_public_path__ + "static/TungstenCompressed-Bold-51a01ec2bcecf447d7cd6aedfa71febd.woff2";